
import api from "."

const SYNC_STATE = "sync"
const NOT_SYNC_STATE = "not_sync"
const LOCK_STATE = "lock"
var state = NOT_SYNC_STATE
var global_attrs
var global_attrs_in_query
var global_object_type_reference
var global_parcel_type_reference
var global_position_in_object_type_reference
var global_key_parameter_type_reference
var global_functional_sub_group_reference

async function load(self)
{
	state = LOCK_STATE

	var response = await api.call_without_component(self, "cadastral_attrs", "get_for_cadastral_objects", {})
	var attrs = []
	var attrs_in_query = []

	response.attrs.forEach(
		value =>
		{
			var attr = {
				id : value.id,
				key : value.key,
				name : value.name,
				label : value.name,
				type : value.type,
				type_info : value.type_info,
				show : value.show,
				sortable : true,
				in_query : true,
				lfr : value.lfr,
				not_real : false,
				real : true,
				mask : value.mask,
				placeholder : value.placeholder,
				is_factor : value.creation_source && value.creation_source.includes("ЦОФ"),
			}

			if(value.reference == null)
				attr.reference = null
			else
			{
				value.reference.values = value.reference.values.sort()
				attr.reference = value.reference
			}

			attrs.push(attr)
			attrs_in_query.push(attr)
		})

	global_attrs = attrs
	global_attrs_in_query = attrs_in_query
	global_position_in_object_type_reference = ( global_attrs.find(attr => attr.key == "attrs.PositionInObject_.Levels.Level.Type") || {}).reference
	/* TODO BFT global_object_type_reference = response.object_type_reference
	global_parcel_type_reference = response.parcel_type_reference
	global_key_parameter_type_reference = response.key_parameter_type_reference
	global_functional_sub_group_reference = response.functional_sub_group_reference
	*/

	state = SYNC_STATE
}

function move_cadastral_number_on_top(arr)
{
	arr.sort(
		( left_attr, right_attr ) =>
		{
			if(left_attr.key == "attrs.CadastralNumber")
				return -1

			if(right_attr.key == "attrs.CadastralNumber")
				return 1

			return 0
		})
}

function sort_attrs_by_keys(attrs, keys)
{
	const _attrs = []

	keys.forEach((key) => {
		const attr = attrs.find((value) => value.key === key)

		if (attr)
		{
			_attrs.push(attr)
		}
	})

	return _attrs
}

async function get(self, keys_if_all_attrs_hidden = [ "attrs.CadastralNumber", "attrs.Name" ])
{
	while(state == LOCK_STATE)
		await new Promise(resolve => setTimeout(resolve, 200))

	if(state == NOT_SYNC_STATE)
		await load(self)

	const prev_attr_visible_keys = self ? api.storage.get(self, api.storage.name(self, "attr_visible_keys"), [], Array) : []
	var attrs_visible

	if(prev_attr_visible_keys.length)
	{
		attrs_visible = []

		prev_attr_visible_keys.forEach(
			key =>
			{
				var attr = global_attrs.find(attr => attr.key == key)

				if(attr)
					attrs_visible.push(attr)
			})
	}
	else
	{
		attrs_visible = global_attrs.filter(attr => keys_if_all_attrs_hidden.includes(attr.key))
		attrs_visible = sort_attrs_by_keys(attrs_visible, keys_if_all_attrs_hidden)
	}

	if(attrs_visible.length == 0)
		attrs_visible = [ global_attrs[0] ]

	var attr_uprs = global_attrs.find(attr => attr.key == "attrs.uprs")

	return {
			attrs : global_attrs,
			attrs_visible : attrs_visible,
			attrs_in_query : global_attrs_in_query,
			attr_uprs : attr_uprs,
			position_in_object_type_reference : global_position_in_object_type_reference,
			object_type_reference : global_object_type_reference,
			parcel_type_reference : global_parcel_type_reference,
			key_parameter_type_reference : global_key_parameter_type_reference,
			functional_sub_group_reference : global_functional_sub_group_reference,
		}
}

export default 
{
	load,
	get,
	move_cadastral_number_on_top,
	sort_attrs_by_keys
}

